import React, { useState, useEffect } from "react";
import axios from "axios";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

export default function SurveyForm({ id, name, onSuccess, survey }) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    const req = {
      ...formData,
    };

    axios
      .post(`/surveys/`, req)
      .then(({ data }) => {
        onSuccess(data.response[0].id);
      })
      .then(() => setLoading(false))
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      id,
    };

    axios
      .put(`/surveys/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("name"),
      initialValue: name,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
    {
      name: "version_name",
      label: t("cs:survey:first_version_name"),
      initialValue: "",
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
      visible: !id,
    },
    {
      name: "instruction_text",
      label: t("cs:survey:instruction_text"),
      initialValue: survey?.instruction_text || "",
      textarea: true,
      required: true,
      schema: () => Yup.string().required(t("validation:required")),
    },
  ].filter((f) => f.visible !== false);

  return (
    <div>
      <BasicForm
        loading={loading}
        onSubmit={onSubmit}
        fields={fields}
        buttonProps={{
          fullWidth: id ? false : true,
        }}
      />
    </div>
  );
}
